// extracted by mini-css-extract-plugin
export default {"worksBlock":"works_block_worksBlock__yj2Sa","title":"works_block_title__tjG9J","someText":"works_block_someText__70RyP","uniqText":"works_block_uniqText__Ue-uh"};